import { Box, Typography } from "@mui/material";
import {currency} from '../../utils/formatters'
const TYPE = {
  success: {
    bar: "#639922",
    bg: "#EAF3DE",
    text: "#27500A",
  },
  warning: {
    bar: "#BA7517",
    bg: "#FAEEDA",
    text: "#633806",
  },
  danger: {
    bar: "#E24B4A",
    bg: "#FCEBEB",
    text: "#791F1F",
  },
};

export default function StatCard({
  title,
  value,
  sub_title,
  tag,
  type = "success",
  id,
  infoText = "",
  meta_text = ""
}) {
  const t = TYPE[type] || TYPE.success;

  const scrollToSection = (id) => {
    const el = document.getElementById(id);

    if (!el) {
      console.warn(`Section not found: ${id}`);
      return;
    }

    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Box
      onClick={() => scrollToSection(id)}
      sx={{
        position: "relative",
        bgcolor: "#FFFFFF",
        border: "0.5px solid #E8E6E1",
        borderRadius: "12px",
        p: "17px 18px",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",

        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
        },
      }}
    >
      {/* Top bar */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "2px",
          bgcolor: t.bar,
        }}
      />

      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            color: "rgba(20,20,20,0.6)",
          }}
        >
          {title}
        </Typography>

        {tag && (
          <Box
            sx={{
              fontSize: "10px",
              fontWeight: 500,
              px: "8px",
              py: "2px",
              borderRadius: "100px",
              bgcolor: t.bg,
              color: t.text,
              whiteSpace: "nowrap",
            }}
          >
            {tag}
          </Box>
        )}
      </Box>

      {/* Value */}
      <Typography
        sx={{
          fontSize: "26px",
          fontWeight: 500,
          color: "#111",
          letterSpacing: "-0.02em",
          lineHeight: 1,
          mb: 0.5,
        }}
      >
        {currency(value)}
      </Typography>

      {/* Subtext */}
      <Typography
        sx={{
          fontSize: "11.5px",
          color: "rgba(20,20,20,0.55)",
        }}
      >
        {sub_title}
      </Typography>

      {infoText && (
        <Typography
          sx={{
            fontSize: "11px",
            color: "rgba(20,20,20,0.45)",
            mt: 0.8,
          }}
        >
          {infoText}
        </Typography>
      )}

      {meta_text && (
  <Typography
    sx={{
      fontSize: "11.5px",
      fontWeight: 500,
      color: t.text, // ties to card intent (green/orange/red)
      mt: 1,
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      cursor: "pointer",
      transition: "all 0.15s ease",

      "&:hover": {
        opacity: 0.8,
        textDecoration: "underline",
      },
    }}
  >
    {meta_text}
    <Box component="span" sx={{ fontSize: "12px" }}>
      →
    </Box>
  </Typography>
)}
    </Box>
  );
}